import { DefaultButton, Dropdown, PrimaryButton } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { noSelectionKey } from '../../../../utilities/filterAndSortingsUtil';
import {
  isChosenOptionsMapper,
  kleOptionsMapperWithNumber,
} from '../../../../utilities/mapperFunctions';

export const FilterDropdownsAndButtons = ({
  mainGoupKleHierarchyOptions,
  subGoupKleHierarchyOptions,
  onChangeKleMainGroupDropdown,
  selectedMainGroupKey,
  onChangeKleSubGroupDropdown,
  onChangeIsChosenDropdown,
  selectedSubGroupKey,
  onCancelButtonClick,
  onSaveButtonClick,
  disableDropdownAndButton,
  selectedIsChosenKey,
}) => {
  const { t: translator } = useTranslation();

  return !disableDropdownAndButton ? (
    <div className="administration-page-kle-dropdown-and-buttons">
      <div>
        <div className="admin-page-container-filters-specific">
          <Dropdown
            label={translator('pages.adminKleMappings.showKleNumbers')}
            styles={filterDropdownStyles}
            options={isChosenOptionsMapper(translator)}
            onChange={onChangeIsChosenDropdown}
            selectedKey={selectedIsChosenKey}
          />
        </div>
        <div className="admin-page-container-filters-specific">
          <Dropdown
            label={translator('pages.adminKleMappings.kleMainGroupNumber')}
            styles={filterDropdownStyles}
            options={kleOptionsMapperWithNumber(translator)(
              mainGoupKleHierarchyOptions,
            )}
            onChange={onChangeKleMainGroupDropdown}
            selectedKey={selectedMainGroupKey}
          />
        </div>
        <div className="admin-page-container-filters-specific">
          <Dropdown
            label={translator('pages.adminKleMappings.kleSubGroupNumber')}
            styles={filterDropdownStyles}
            options={kleOptionsMapperWithNumber(translator)(
              subGoupKleHierarchyOptions,
            )}
            onChange={onChangeKleSubGroupDropdown}
            selectedKey={selectedSubGroupKey}
            disabled={selectedMainGroupKey === noSelectionKey}
          />
        </div>
      </div>
      <div className="administration-page-buttons">
        <DefaultButton
          text={translator('global.cancel')}
          iconProps={{ iconName: 'Cancel' }}
          onClick={onCancelButtonClick}
        />
        <PrimaryButton
          text={translator('global.save')}
          iconProps={{ iconName: 'Save' }}
          onClick={onSaveButtonClick}
        />
      </div>
    </div>
  ) : null;
};

const filterDropdownStyles = {
  dropdown: {
    width: 180,
    height: 32,
  },
  dropdownOptionText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};
